import {
    ComponentParams,
    ComponentRendering,
    Field,
    useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import GenericHeader, { GenericHeaderProps } from "components/ui/GenericHeader";
import { Box, Flex } from "@chakra-ui/react";
import SCText from "components/sc/SCText";
import { useEffect, useRef } from "react";
import { useRouter } from "next/router";
interface Fields {
    Url: Field<string>;
    Title: Field<string>;
    DesktopHeight: Field<number>;
    MobileHeight: Field<number>;
}

interface Fields extends GenericHeaderProps {
    fields: Fields;
}

export type IFrameProps = {
    rendering: ComponentRendering & { params: ComponentParams };
    params: { [key: string]: string };
    fields: Fields;
};

const IFrame = (props: IFrameProps) => {
    const {
        sitecoreContext: { pageEditing },
    } = useSitecoreContext();

    const { query } = useRouter();

    const utmSource = query.utm_source && `utm_source=${query.utm_source}`;
    const utmMedium = query.utm_medium && `utm_medium=${query.utm_medium}`;
    const utmCampaign = query.utm_campaign && `utm_campaign=${query.utm_campaign}`;
    const utmArray = [utmSource, utmMedium, utmCampaign];
    const utmString = utmArray.filter((utm) => utm).join("&");

    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        if (iframeRef.current) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const iFrameResize = require("iframe-resizer/js/iframeResizer");
            iFrameResize(
                {
                    checkOrigin: false,
                    heightCalculationMethod: "lowestElement",
                    scrolling: false,
                    autoResize: true,
                },
                iframeRef.current
            );
        }
    }, []);

    return (
        <GenericHeader
            Id={props.rendering.uid}
            HeaderHeadline={props.fields?.HeaderHeadline}
            HeaderSubHeadline={props.fields?.HeaderSubHeadline}
            HeaderCTA={props.fields?.HeaderCTA}
            headlineSize={props.params?.HeaderHeadlineSize}
        >
            {pageEditing && (
                <Flex flexDirection="column" gap="sp16" mb="sp16">
                    <Flex flexDirection="column">
                        Title:
                        <SCText
                            textField={props.fields?.Title}
                            border="1px solid black"
                            mt="sp12"
                        />
                    </Flex>
                    <Flex flexDirection="column">
                        Iframe URL:
                        <SCText
                            textField={props.fields?.Url}
                            border="1px solid black"
                            mt="sp12"
                            wordBreak="break-word"
                        />
                    </Flex>
                </Flex>
            )}
            <Box
                sx={{
                    "> iframe": {
                        height: {
                            base: `${
                                props.fields?.MobileHeight?.value !== undefined
                                    ? props.fields?.MobileHeight?.value + "px"
                                    : "auto"
                            }`,
                            lg: `${
                                props.fields?.DesktopHeight?.value !== undefined
                                    ? props.fields?.DesktopHeight.value + "px"
                                    : "auto"
                            }`,
                        },
                    },
                }}
            >
                <iframe
                    ref={iframeRef}
                    width="100%"
                    height="100%"
                    title={props.fields?.Title.value}
                    src={props.fields?.Url.value + (utmString ? `?${utmString}` : "")}
                />
            </Box>
        </GenericHeader>
    );
};
export default IFrame;
